import styled from '@emotion/styled';
import { Trans } from '@lingui/react';
import { Text } from '@mindbaz/ui-v2';

import bgImage from 'assets/login-bg.jpg';
import mindbazLogo from 'assets/mindbaz-logo-blanc.png';

const Wrapper = styled('div')({
  backgroundColor: '#313B51',
  backgroundImage: `url(${bgImage})`,
  backgroundPosition: 'cente',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

const MainContainer = styled('div')({
  margin: 'auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
});

const IconMindbaz = styled('img')({
  width: 600,
  marginBottom: 40,
});

const AccessDenied = () => (
  <Wrapper>
    <MainContainer>
      <IconMindbaz alt="logo" src={mindbazLogo} />
      <Text variant="h1" weight="bold" color="secondary">
        <Trans
          id="oops"
          message="Oops! You don't have access to this platform."
        />
      </Text>
    </MainContainer>
  </Wrapper>
);

export default AccessDenied;
